<template>
  <div>
    <h3 class="h4">
      {{ $tc('voip.call.participants', participants.length) }}
    </h3>
    <ListStacked>
      <li v-for="(participant, i) in participants" :key="i">
        <Participant :participant="participant" />
      </li>
    </ListStacked>
  </div>
</template>

<script>
import Participant from './Participant';

export default {
  components: {
    Participant,
  },

  props: {
    participants: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
